import { Outlet } from 'react-router-dom';
import FilterSubSidebar from '../components/filter/FilterSubSidebar';

export default function FilterLayout() {
  return (
    <div className="flex -m-6" style={{ height: 'calc(100% + 48px)' }}>
      <FilterSubSidebar />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
